'use client';

import { Button } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

export function MentorSearchBackButton() {
  const router = useRouter();
  // Start with false to match SSR and avoid hydration errors
  const [canGoBack, setCanGoBack] = useState(false);

  useEffect(() => {
    // Only check client-only APIs after component mounts
    const hasHistory = window.history.length > 1;
    const sessionFlag = sessionStorage.getItem('fromMentorSearch') === 'true';
    const referrer = document.referrer;
    const referrerCheck = referrer.includes('/mentors') && !referrer.includes('/mentors/');
    const shouldShow = hasHistory && (sessionFlag || referrerCheck);
    
    setCanGoBack(shouldShow);
  }, []);

  if (!canGoBack) return null;

  return (
    <>
      {/* Mobile: Icon only button */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.7 }}
        style={{
          position: 'absolute',
          top: '-0.5rem',
          left: '0.5rem',
          zIndex: 10,
        }}
        className="mobile-back-button"
      >
        <Button
          variant="subtle"
          color="gray"
          onClick={() => router.back()}
          size="sm"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(8px)',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            padding: '0.5rem',
            minWidth: 'auto',
            width: '36px',
            height: '36px',
          }}
        >
          <IconArrowLeft size={18} />
        </Button>
      </motion.div>

      {/* Desktop: Icon + text button */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.7 }}
        style={{
          position: 'absolute',
          top: '1rem',
          left: '1rem',
          zIndex: 10,
        }}
        className="desktop-back-button"
      >
        <Button
          variant="subtle"
          color="gray"
          leftSection={<IconArrowLeft size={16} />}
          onClick={() => router.back()}
          size="sm"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(8px)',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          Back to search
        </Button>
      </motion.div>
    </>
  );
}
